import React, { useState, useEffect } from 'react';
import AdminPage from '../pages/AdminPage';
import AdminLogin from './AdminLogin';
import { clearAdminToken, getAdminToken, isAdminAuthenticated } from '../utils/adminAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const AdminRoute: React.FC = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      const token = getAdminToken();
      if (!token) {
        setChecking(false);
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/auth/verify`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          setAuthenticated(true);
        } else {
          clearAdminToken();
        }
      } catch {
        clearAdminToken();
      } finally {
        setChecking(false);
      }
    };

    verifySession();
  }, []);

  const handleLogin = () => {
    setAuthenticated(true);
  };

  const handleLogout = () => {
    clearAdminToken();
    setAuthenticated(false);
  };

  if (checking) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-300 rounded w-1/4 mb-6"></div>
          <div className="h-64 bg-gray-300 rounded"></div>
        </div>
      </div>
    );
  }

  if (!authenticated && !isAdminAuthenticated()) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return <AdminPage onLogout={handleLogout} />;
};

export default AdminRoute;
